import React from 'react'
import {Link} from 'react-router-dom'

const CheckoutSteps = ({step1, step2, step3, step4}) => {
  return (
    <div className="navbar">
        {/* {step1 ? <Link className="nav" to='/login'>SignIn</Link> : <span className="nav">SignIn</span>} */}
        {step2 ? <Link className="nav" to='/checkout/shipping'>Shipping</Link>: <span className="nav">Shipping</span>}
        {step3 ? <Link className="nav" to='/checkout/payment'>Payment</Link>: <span className="nav">Payment</span>}
        {step4 ? <Link className="nav" to='/checkout/confirm'>Place Order</Link>: <span className="nav">Place Order</span>}       
    </div>
  )
}

export default CheckoutSteps